import React from "react";
import { usDateFormat } from "../../../utils";

const ScheduleRunSummaryContainer = ({ scheduleRunResponse }) => {
  const ScheduleFrequencyOptions = () => {
    switch (scheduleRunResponse?.schedule?.scheduleType) {
      case 1:
        return "Annually";
      case 2:
        return "Semi Annually";
      case 3:
        return "Monthly";
      case 4:
        return "Semi-Monthly";
      case 5:
        return "Quarterly";
      case 6:
        return "Weekly";
      case 7:
        return "Daily";
    }
  };

  const ScheduleFrequencyAnnually = () => {
    switch (scheduleRunResponse?.schedule?.monthAnnually) {
      case 1:
        return "January";
      case 2:
        return "February";
      case 3:
        return "march";
      case 4:
        return "April";
      case 5:
        return "May";
      case 6:
        return "June";
      case 7:
        return "July";
      case 8:
        return "August";
      case 9:
        return "September";
      case 10:
        return "October";
      case 11:
        return "November";
      case 12:
        return "December";
    }
  };
  const ScheduleFrequencySemiAnnually = () => {
    switch (scheduleRunResponse?.schedule?.monthSemiAnnually) {
      case 1:
        return "January";
      case 2:
        return "February";
      case 3:
        return "march";
      case 4:
        return "April";
      case 5:
        return "May";
      case 6:
        return "June";
      case 7:
        return "July";
      case 8:
        return "August";
      case 9:
        return "September";
      case 10:
        return "October";
      case 11:
        return "November";
      case 12:
        return "December";
    }
  };
  const ScheduleFrequencyQuaterly = () => {
    switch (scheduleRunResponse?.schedule?.monthQuarterly) {
      case 1:
        return "January";
      case 2:
        return "February";
      case 3:
        return "march";
      case 4:
        return "April";
      case 5:
        return "May";
      case 6:
        return "June";
      case 7:
        return "July";
      case 8:
        return "August";
      case 9:
        return "September";
      case 10:
        return "October";
      case 11:
        return "November";
      case 12:
        return "December";
    }
  };
  const ScheduleFrequencyWeekly = () => {
    switch (scheduleRunResponse?.schedule?.startDayWeekly) {
      case 0:
        return "Sunday";
      case 1:
        return "Monday";
      case 2:
        return "Tuesday";
      case 3:
        return "Wednesday";
      case 4:
        return "Thursday";
      case 5:
        return "Friday";
      case 6:
        return "Saturday";
    }
  };
  const basisAsOfFrequency = () => {
    switch (scheduleRunResponse?.basisAsOfFrequency) {
      case 1:
        return "Month(s) back";
      case 2:
        return "Week(s) back";
      case 3:
        return "Day(s) back";
    }
  };

  return (
    <div className="fee-summary-conatiner">
      <div className="fee-applicable">
        <div className="schedule-run1">
          <span className="fw-500 ft-14 headerDetails">
            Fee run
            {scheduleRunResponse.feeRunType == 1 ? (
              <p className="fw-600 ft-16 valueDetails">{"One-Time"}</p>
            ) : (
              <p className="fw-600 ft-16 valueDetails">{"Recurring"}</p>
            )}
          </span>
          {scheduleRunResponse.feeRunType == 1 && (
            <span className="fw-500 ft-14 headerDetails">
              Fee process
              {scheduleRunResponse.feeProcess == 1 ? (
                <p className="fw-600 ft-16 valueDetails">{"Immediate"}</p>
              ) : (
                <p className="fw-600 ft-16 valueDetails">{"Future"}</p>
              )}
            </span>
          )}

          {scheduleRunResponse.feeRunType == 1 &&
            scheduleRunResponse.feeProcess == 2 && (
              <span className="fw-500 ft-14 headerDetails">
                Process date
                <p className="fw-600 ft-16 valueDetails">
                  {usDateFormat(scheduleRunResponse?.processDate)}
                </p>
              </span>
            )}

          {/* <span className="fw-500 ft-14 headerDetails">
            Basis of date
            {scheduleRunResponse.basisDate == 1 ? (
              <p className="fw-600 ft-16 valueDetails">{"Process Date"}</p>
            ) : (
              <p className="fw-600 ft-16 valueDetails">{"Other"}</p>
            )}
          </span> */}

          {scheduleRunResponse.feeRunType == 2 && (
            <>
              <span className="fw-500 ft-14 headerDetails">
                Fee effective date
                {scheduleRunResponse.effectiveStartDate !== null ? (
                  <p className="fw-600 ft-16 valueDetails">
                    {usDateFormat(scheduleRunResponse.effectiveStartDate)}
                  </p>
                ) : (
                  <p className="fw-600 ft-16 valueDetails">{"-"}</p>
                )}
              </span>
              <span className="fw-500 ft-14 headerDetails">
                Fee end date
                {scheduleRunResponse.effectiveEndDate !== null ? (
                  <p className="fw-600 ft-16 valueDetails">
                    {usDateFormat(scheduleRunResponse.effectiveEndDate)}
                  </p>
                ) : (
                  <p className="fw-600 ft-16 valueDetails">{"-"}</p>
                )}
              </span>
            </>
          )}

          <span className="fw-500 ft-14 headerDetails">
            Basis as of date
            {scheduleRunResponse?.basisDate == null ? (
              <p className="fw-600 ft-16 valueDetails">{"-"}</p>
            ) : (
              <>
                {scheduleRunResponse?.basisDate == 1 ? (
                  <p className="fw-600 ft-16 valueDetails">{"Process Date"}</p>
                ) : (
                  <p className="fw-600 ft-16 valueDetails">{"Other"}</p>
                )}
              </>
            )}
          </span>

          {scheduleRunResponse?.basisDate == 2 && (
            <span className="fw-500 ft-14 headerDetails">
              Basis as of other
              {scheduleRunResponse.basisAsOfDate !== null ? (
                <p className="fw-600 ft-16 valueDetails">
                  {scheduleRunResponse.basisAsOfDate +
                    " " +
                    basisAsOfFrequency()}
                </p>
              ) : (
                <p className="fw-600 ft-16 valueDetails">{"-"}</p>
              )}
            </span>
          )}

          {scheduleRunResponse?.feeProcess == 2 && (
            <span className="fw-500 ft-14 headerDetails">
              Process time
              <p className="fw-600 ft-16 valueDetails">
                {scheduleRunResponse?.processTimeMinutes} :{" "}
                {scheduleRunResponse?.processTimeHours}
              </p>
            </span>
          )}
        </div>
        {scheduleRunResponse?.feeRunType == 2 && (
          <hr style={{ borderStyle: "dashed", color: " #000 " }}></hr>
        )}

        {scheduleRunResponse?.feeRunType == 2 && (
          <div>
            <div className="fw-600 ft-16 valueDetails">Schedule</div>
            <br></br>

            <div className="schedule-details1">
              <span className="fw-500 ft-14 headerDetails">
                Schedule frequency
                {true ? (
                  <p className="fw-600 ft-16 valueDetails">
                    {ScheduleFrequencyOptions()}
                  </p>
                ) : (
                  <p className="fw-600 ft-16 valueDetails">{"-"}</p>
                )}
              </span>

              {scheduleRunResponse?.schedule?.scheduleType == 1 && (
                <>
                  <span className="fw-500 ft-14 headerDetails">
                    Starting month
                    <p className="fw-600 ft-16 valueDetails">
                      {ScheduleFrequencyAnnually()}
                    </p>
                  </span>
                  <span className="fw-500 ft-14 headerDetails">
                    Day of the month
                    <p className="fw-600 ft-16 valueDetails">
                      {scheduleRunResponse?.schedule?.dayAnnually}
                    </p>
                  </span>
                </>
              )}

              {scheduleRunResponse?.schedule?.scheduleType == 2 && (
                <>
                  <span className="fw-500 ft-14 headerDetails">
                    Starting month of the half year
                    <p className="fw-600 ft-16 valueDetails">
                      {ScheduleFrequencySemiAnnually()}
                    </p>
                  </span>
                  <span className="fw-500 ft-14 headerDetails">
                    Day of the month
                    <p className="fw-600 ft-16 valueDetails">
                      {scheduleRunResponse?.schedule?.daySemiAnnually}
                    </p>
                  </span>
                </>
              )}

              {scheduleRunResponse?.schedule?.scheduleType == 3 && (
                <>
                  <span className="fw-500 ft-14 headerDetails">
                    Start day of every month
                    <p className="fw-600 ft-16 valueDetails">
                      {scheduleRunResponse?.schedule?.startDay}
                    </p>
                  </span>
                </>
              )}

              {scheduleRunResponse?.schedule?.scheduleType == 4 && (
                <>
                  <span className="fw-500 ft-14 headerDetails">
                    First begin date
                    <p className="fw-600 ft-16 valueDetails">
                      {scheduleRunResponse?.schedule?.firstDate}
                    </p>
                  </span>
                  <span className="fw-500 ft-14 headerDetails">
                    Second begin date
                    <p className="fw-600 ft-16 valueDetails">
                      {scheduleRunResponse?.schedule?.secondDate}
                    </p>
                  </span>
                </>
              )}

              {scheduleRunResponse?.schedule?.scheduleType == 5 && (
                <>
                  <span className="fw-500 ft-14 headerDetails">
                    Starting month for the first quarter
                    <p className="fw-600 ft-16 valueDetails">
                      {ScheduleFrequencyQuaterly()}
                    </p>
                  </span>
                  <span className="fw-500 ft-14 headerDetails">
                    Day of the month
                    <p className="fw-600 ft-16 valueDetails">
                      {scheduleRunResponse?.schedule?.dayQuarterly}
                    </p>
                  </span>
                </>
              )}

              {scheduleRunResponse?.schedule?.scheduleType == 6 && (
                <>
                  <span className="fw-500 ft-14 headerDetails">
                    Start day
                    <p className="fw-600 ft-16 valueDetails">
                      {ScheduleFrequencyWeekly()}
                    </p>
                  </span>
                </>
              )}
              {scheduleRunResponse?.schedule?.scheduleType != 3 &&
                scheduleRunResponse?.schedule?.scheduleType != 6 &&
                scheduleRunResponse?.schedule?.scheduleType != 7 && (
                  <>
                    <span className="mt-4 fw-500 ft-14 headerDetails">
                      Process time
                      <p className="fw-600 ft-16 valueDetails">
                        {scheduleRunResponse?.processTimeMinutes} :{" "}
                        {scheduleRunResponse?.processTimeHours}
                      </p>
                    </span>
                  </>
                )}
              {scheduleRunResponse?.schedule?.scheduleType != 1 &&
                scheduleRunResponse?.schedule?.scheduleType != 2 &&
                scheduleRunResponse?.schedule?.scheduleType != 4 &&
                scheduleRunResponse?.schedule?.scheduleType != 5 && (
                  <>
                    <span className="processTime">
                      Process time
                      <p className="fw-600 ft-16 valueDetails">
                        {scheduleRunResponse?.processTimeMinutes} :{" "}
                        {scheduleRunResponse?.processTimeHours}
                      </p>
                    </span>
                  </>
                )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ScheduleRunSummaryContainer;
